<template>
    <vue-element-loading v-if="isDark()" :active="active" color="#fff" background-color="rgba(34, 34, 34, 0.9)"/>
    <vue-element-loading v-else :active="active"/>
</template>

<script>
    export default {
        name: "Loader",
        props: {
            active: Boolean,
        },
        methods: {
            isDark() {
                return window.CURRENT_THEME_DARK;
            }
        }
    }
</script>

<style scoped>

</style>